import { IntegrationProvider } from '~/codegen/graphql'
import { GetCodeSourceConnectionsDocument } from './use-code-source-connection.generated'

export default function useCodeSourceConnection() {
  const { data, isDone } = useQuery({
    query: GetCodeSourceConnectionsDocument,
    tags: ['IntegrationProviders'],
  })

  function isConnected(provider: IntegrationProvider) {
    const match = data.value?.integrationProviders?.find((p) => p.provider === provider)
    return !!match?.connections && match.connections.length > 0
  }

  const isGithubConnected = computed(() => isConnected(IntegrationProvider.Github))
  const isBitbucketConnected = computed(() => isConnected(IntegrationProvider.Bitbucket))
  const isAnyCodeSourceConnected = computed(() => isGithubConnected.value || isBitbucketConnected.value)

  return { isGithubConnected, isBitbucketConnected, isAnyCodeSourceConnected, isDone }
}
